import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PropsOnlyChildren } from '@domain/types/prop.types';
import { gameInfos } from '@data/game.infos';
import { GameList } from '@domain/game.selection/game.list';
import { GameSelectionProvider } from '@domain/game.selection/game.selection.provider';

const gamePath = `/:gameUrlId(${gameInfos.map((g) => g.urlId).join('|')})`;

export const GameSelection = ({ children }: PropsOnlyChildren) => {
  return (
    <Switch>
      <Route path={gamePath}>
        <GameSelectionProvider>{children}</GameSelectionProvider>
      </Route>
      <Route path='*' component={GameList} />
    </Switch>
  );
};
